export enum AssetClass {
  Art,
  Cash,
  Commodity,
  Currency,
  Derivative,
  DirectInvestments,
  Equity,
  FixedIncome,
  Forest,
  MixedAllocation,
  PrivateDebt,
  PrivateEquity,
  RealEstate,
  Specialty,
  Structured,
  Crypto,
}
